<template>
  <div class="delighted-loader" />
</template>

<script>
export default {
  name: "DelightedLoader",
  props: {
    userInfo: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      surveyLaunched: false,
    };
  },
  watch: {
    userInfo: {
      handler(newUser) {
        if (
          newUser &&
          newUser.email &&
          newUser.first_name &&
          newUser.last_name
        ) {
          this.loadDelighted(newUser);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    loadDelighted(userInfo) {
      if (this.surveyLaunched) {
        return;
      }

      this.injectSnippet();
      this.launchSurvey(userInfo);
      this.surveyLaunched = true;
    },
    injectSnippet() {
      if (window.delighted && window.delighted.SNIPPET_VERSION) {
        return;
      }

      // Delighted snippet (loads asynchronously so it does not impact performance)
      (function (e, t, r, n) {
        if (!e[n]) {
          const a = (e[n] = []);
          const i = [
            "survey",
            "reset",
            "config",
            "init",
            "set",
            "get",
            "event",
            "identify",
            "track",
            "page",
            "screen",
            "group",
            "alias",
          ];
          for (let c = 0; c < i.length; c += 1) {
            const s = i[c];
            a[s] =
              a[s] ||
              (function (e) {
                return function () {
                  const t = Array.prototype.slice.call(arguments);
                  a.push([e, t]);
                };
              })(s);
          }
          a.SNIPPET_VERSION = "1.0.1";
          const o = t.createElement("script");
          o.type = "text/javascript";
          o.async = true;
          o.src =
            "https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/" +
            r +
            "/" +
            n +
            ".js";
          const p = t.getElementsByTagName("script")[0];
          p.parentNode.insertBefore(o, p);
        }
      })(window, document, "3cS8CAHFJ9gzOvDn", "delighted");
    },
    launchSurvey(userInfo) {
      if (!window.delighted) {
        return;
      }

      const business = userInfo.current_business || {};
      const subscription =
        business.subscription && business.subscription.name
          ? business.subscription.name
          : undefined;

      window.delighted.survey({
        email: userInfo.email,
        name: `${userInfo.first_name} ${userInfo.last_name}`.trim(),
        createdAt: userInfo.created_at || userInfo.createdAt,
        properties: {
          company: business.name,
          subscription,
        },
      });
    },
  },
};
</script>

<style scoped>
.delighted-loader {
  display: none;
}
</style>
